import {SUBSCRIBE_PLAN_STATE, SubscriptionPlanController} from "./SubscriptionPlanController.js";
import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {
    ADDRESS_PANEL_URL,
    INLINE_GIFT_SUBSCRIPTION_URLS,
    PAYMENT_FAILED_PANEL_URL,
    SUBSCRIPTION_PLAN_PANEL_URL
} from "../PanelConstants.js";
import {apiSubscribe} from "../../../client/state/SubscriptionStore.js";
import {wrapInSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {CARD_SECTION_STATE, PaymentMethodController} from "./PaymentMethodController.js";
import {Messages} from "../../Messages.js";
import {PaymentMethodStore} from "../../../client/state/PaymentMethodStore.js";
import {ADDRESS_SECTION_STATE} from "../pages/panels/address/AddressPanel.jsx";
import {getSubscribeEndpointPayload} from "./SubscriptionFlowHandler.js";
import {Controller} from "./Controller.js";
import {AddressController} from "./AddressController.js";
import {iFrameState} from "../../services/IFrameState.js";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {iFrameAuthService} from "../../services/IFrameAuthService.js";
import {BaseFlowHandler} from "./BaseFlowHandler.js";


export class GiftSubscriptionFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.giftSubscription;
    giftBeneficiaryEmailAddress = "";
    name = "";
    message = "";

    start() {
        const {skipCTA} = iFrameState;

        Controller.subscriptionPlan = new SubscriptionPlanController({
            subscriptionPlanState: SUBSCRIBE_PLAN_STATE.giftSubscription,
            selectedOffer: null,
            onSelectSuccess: async () => {
                await iFrameAuthService.promptAuthenticationIfNeeded();
                // If we come from login page and switch to review, we want the back to take us to the plans
                // page. Currently, this is how we achieve that without disrupting the flow in any way.
                Router.localHistory.push(SUBSCRIPTION_PLAN_PANEL_URL);
                if (this.giftBeneficiaryEmailAddress) {
                    await this.onGiftDetailsProvided();
                    return;
                }
                Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.giftDetails);
            }
        });

        if (skipCTA) {
            Router.changeURL(SUBSCRIPTION_PLAN_PANEL_URL);
        } else {
            Router.changeToCustomPanel();
        }
    }

    async onGiftDetailsProvided() {
        Controller.paymentMethod = new PaymentMethodController({
            cardSectionState: CARD_SECTION_STATE.chooseCard,
            savePaymentMethod: true,
            getScope: () => PaymentMethodStore.Scope.PRIVATE,
            onSelectSuccess: () => this.giftSubscription(),
        });

        if (!Controller.subscriptionPlan.selectedOffer.shouldCollectAddress()) {
            await Controller.subscriptionPlan.fetchPrices(Controller.address?.selectedAddress);
            Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.reviewOrder);
            return;
        }

        Controller.address = new AddressController({
            addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
            onSelectSuccess: async () => {
                await Controller.subscriptionPlan.fetchPrices(Controller.address?.selectedAddress);
                Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.reviewOrder);
            },
            onSelectCancel: () => Router.back(),
            continueLabel: Messages.reviewOrder,
        });

        Router.changeURL(ADDRESS_PANEL_URL);
    }

    @wrapInSpinner
    async giftSubscription() {
        try {
            const subscriptionDetails = await getSubscribeEndpointPayload();
            Object.assign(subscriptionDetails.metadata, {
                gift: true,
                giftFrom: this.name,
                giftMessage: this.message,
            });
            await apiSubscribe({
                ...subscriptionDetails,
                gift: true,
                giftBeneficiaryEmailAddress: this.giftBeneficiaryEmailAddress,
            });
        } catch (error) {
            Controller.paymentMethod.update({
                paymentError: error,
            });
            Router.changeURL(PAYMENT_FAILED_PANEL_URL);
            return;
        }
        Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.success);
    }
}
